<template>
  <div class="ProductList3">
    <section class="section home-section bg white pb-sm-5 pb-1">
      <div class="inner-wrap container">
        <div class="products-list set-3 products-type-d row">
          <div v-for="product in field.products" class="col-lg-3">
            <div class="item">
              <div v-if="product" class="product type-d py-2">
                <h5 class="ui text big-lg medium-md tiny-sm small semibold">
                  <router-link :to="'products/item/'+product.id">{{product.titleTH}}</router-link>
                </h5>
                <div class="thumb">
                  <router-link :to="'products/item/'+product.id">
                    <img v-if=" product.images[0]" :src="[ product.images[0].url]" />
                    <img v-else src="../../assets/img/default-noimg.png" />
                  </router-link>
                </div>
                <div class="d-flex align-items-center mt-3">
                  <div class="price">
                    <p
                      class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0"
                    >{{currency}}{{formatPrice(product.netPrice)}}</p>
                    <p
                      v-if="product.netPrice != product.price"
                      class="ui text big-lg medium-md tiny-sm small light line-through m-0"
                    >{{currency}}{{formatPrice(product.price)}}</p>
                  </div>
                  <div class="d-flex align-items-center ml-auto">
                    <AddToCart
                      v-if="product.quantity != 0"
                      :btnStyle="'style1'"
                      :product="product"
                    />
                    <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                    <Favorite :productId="product.id"></Favorite>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import AddToCart from "@/components/cart/AddItem.vue";
import Favorite from "@/components/favorite/AddFavorite.vue";

export default {
  name: "ProductListIII",
  components: {
    AddToCart,
    Favorite
  },
  props: {
    field: {
      type: Object,
      default: {
        products: {
          type: Array,
          default: () => []
        }
      }
    }
  },
  data() {
    return {
      currency: ""
    };
  },
  created() {
    this.currency = this.$parent.currency;
  },
  methods: {
    formatPrice(value) {
      let price = Number(value);
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>